import { AuthenticatedGuard, connector } from './AuthenticatedGuard';

export default connector(AuthenticatedGuard);
